import { useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Tooltip } from 'src/core/ui';
import { InfoOutlineIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

export const MismatchedSectionDisclaimer = () => {
  const { isDarkMode } = useSiteTheme();
  const elementRef = useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(elementRef);

  return (
    <Tooltip
      open={isHovering}
      delayDuration={100}
      contentVariant={isDarkMode ? 'light' : 'dark'}
      align="center"
      triggerContent={
        <div style={{ display: 'flex', alignItems: 'center' }} ref={elementRef}>
          <InfoOutlineIcon
            stroke={vars.color.textError}
            size={vars.iconSize.s}
          />
        </div>
      }
    >
      <Content id={ContentId.MismatchedSectionDisclaimer} />
    </Tooltip>
  );
};
